import api from '@/lib/axios';
import type { PgcRegistrationRow, PgcStatus, UpdatePgcStatusData } from '@/services/pgc-registrations.api';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  return ((r.data as { data?: T }).data ?? r.data) as T;
}

export interface OrgSchoolOption {
  id: string;
  name: string;
}

export interface OrgPgcRegistrationRow extends PgcRegistrationRow {
  schoolId: string;
  schoolName: string;
}

export const OrgPgcRegistrationsApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/pgc-registrations/schools')),

  list: async (params?: { schoolId?: string; status?: PgcStatus }): Promise<OrgPgcRegistrationRow[]> =>
    unwrap(await api.get('/org/pgc-registrations', { params })),

  get: async (id: string, schoolId: string): Promise<OrgPgcRegistrationRow> =>
    unwrap(await api.get(`/org/pgc-registrations/${id}`, { params: { schoolId } })),

  updateStatus: async (id: string, schoolId: string, data: UpdatePgcStatusData): Promise<OrgPgcRegistrationRow> =>
    unwrap(await api.patch(`/org/pgc-registrations/${id}/status`, data, { params: { schoolId } })),

  attachReport: async (id: string, schoolId: string, reportUrl: string): Promise<OrgPgcRegistrationRow> =>
    unwrap(await api.post(`/org/pgc-registrations/${id}/report`, { reportUrl }, { params: { schoolId } })),

  remove: async (id: string, schoolId: string): Promise<void> =>
    unwrap(await api.delete(`/org/pgc-registrations/${id}`, { params: { schoolId } })),
};
